import React, { Component } from 'react';
import { Row } from "antd";
import Table1 from './3-2-1';
import Table2 from './3-2-2';

class index extends Component {
    render() {
        return (
            <div>
                <Row style={{ margin: "24px 0 24px 24px", fontSize: 22, color: "#333" }}>
                    5.7 F&B Outlets KPI Analysis 餐饮部餐厅关键绩效指数分析
                </Row>
                <Table1></Table1>
                <Table2></Table2>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/3.0/3-2/index.js